import React from "react";
import HeaderSection from "../../../components/headerSection";
import Footer from "../home/footer";
import FAQSection from "../home/faqSection";

export const FAQs = () => {
  const faqJson = {
    "General Questions": [
      {
        question: "What is the AI Job Impact Tool?",
        answer:
          "The AI Job Impact Tool is designed to help you understand how AI and automation will impact your current job and future career. It provides personalized insights into your AI literacy, job tasks at risk of automation, and recommendations for upskilling, career transitions, and emerging AI roles.",
      },
      {
        question: "Who can use the AI Job Impact Tool?",
        answer:
          "The tool is designed for professionals looking to understand the impact of AI on their careers. It's suitable for:\n- Individuals assessing their current job's AI risk and potential career opportunities.\n- HR professionals and companies looking to upskill their workforce and future-proof their employees.",
      },
      {
        question: "Is the AI Job Impact Tool free?",
        answer:
          "The AI Job Impact Tool offers both free and paid subscription options. The free tier includes basic features, while the paid tiers unlock personalized career recommendations, upskilling pathways, mentorship, and more.",
      },
    ],
    "AI Literacy Quiz": [
      {
        question: "How does the AI Literacy Quiz work?",
        answer:
          "The AI Literacy Quiz assesses your current digital skills, adaptability to AI, and overall preparedness for an AI-driven workplace. It consists of multiple-choice and Likert-scale questions, covering areas like technical skills, problem-solving, and AI awareness. After completing the quiz, you'll receive a score and personalized feedback.",
      },
      {
        question: "How long does the AI Literacy Quiz take?",
        answer:
          "The quiz takes approximately 10-15 minutes to complete. It's designed to be quick yet comprehensive in assessing your literacy for an AI-driven career.",
      },
      {
        question: "Can I retake the AI Literacy Quiz?",
        answer:
          "Yes! You can retake the quiz at any time, especially after completing upskilling activities or gaining new AI-related skills. The tool will track your progress and update your AI literacy score accordingly.",
      },
    ],
    "Job Impact Assessment": [
      {
        question: "What is the Job Impact Assessment?",
        answer:
          "The Job Impact Assessment evaluates how AI will impact your current job role. It assesses the likelihood of your tasks being automated, augmented by AI, or remaining human-dependent. You will receive a Job Impact Score that shows how much of your role is affected by AI and automation.",
      },
      {
        question: "How does the Job Impact Assessment work?",
        answer:
          "The assessment asks you to identify and rank your current job tasks. Based on your responses, the tool analyzes the risk of those tasks being automated and provides insights into how AI may affect your job.",
      },
      {
        question: "Can I download my Job Impact Report?",
        answer:
          "Yes! After completing the Job Impact Assessment, you will be able to download a comprehensive report detailing the impact of AI on your job, tasks at risk, and personalized recommendations for your career.",
      },
    ],
    "Career Recommendations & Upskilling Pathways": [
      {
        question: "How are career recommendations made?",
        answer:
          "Career recommendations are based on your AI literacy score, current skills, and the AI impact on your role. The tool suggests emerging, lateral, and advancement career pathways that are less impacted by AI or that align with your strengths.",
      },
      {
        question: "What is an Upskilling Pathway?",
        answer:
          "An Upskilling Pathway is a personalized learning journey designed to help you bridge skill gaps and develop the competencies needed for your target career. The tool recommends relevant courses, certifications, and resources based on your AI literacy and career aspirations.",
      },
      {
        question: "How do I get personalized course recommendations?",
        answer:
          "Once the AI Literacy Quiz and Job Impact Assessment are completed, the tool will generate personalized course recommendations based on the skills you need to develop. You'll receive a customized learning plan with suggested online courses, certifications, and resources.",
      },
      {
        question: "Can I track my progress on the Upskilling Pathway?",
        answer:
          "Yes! You can monitor your progress through the Upskilling Pathway dashboard, which shows the courses you've completed, skills gained, and your overall progress towards closing your AI skills gap.",
      },
    ],
    "Mentorship and Community Access": [
      {
        question: "How does the AI Career Mentorship work?",
        answer:
          "The AI Career Mentorship program connects you with experienced professionals in the AI industry. Depending on your subscription tier, you can access free mentorship sessions or purchase additional ones. The mentors provide personalized advice on career transitions, upskilling, and AI industry insights.",
      },
      {
        question: "What is the CareerGenie Chatbot?",
        answer:
          "The CareerGenie Chatbot is an AI-powered assistant that provides personalized career guidance, answers questions about AI job impact, suggests learning resources, and helps you explore career opportunities. It's available for Advanced tier users and helps guide you through your career development.",
      },
      {
        question: "What is the Community feature?",
        answer:
          "The Community feature allows you to interact with other users in forums, learning groups, and through messaging. You can share resources, ask questions, and collaborate with others who are also on the journey of upskilling for AI-driven roles.",
      },
    ],
    "Subscription and Payments": [
      {
        question: "What are the subscription options?",
        answer:
          "We offer three subscription plans:\n- Free Plan: Basic access to the AI literacy quiz and job impact score.\n- Basic Plan: $35/month or $400/year for full AI job impact analysis, career recommendations, and personalized course suggestions.\n- Advanced Plan: $50/month or $500/year for advanced features like personalized skills gap analysis, CareerGenie Chatbot, mentorship sessions, and community access.",
      },
      {
        question: "Can I cancel my subscription?",
        answer:
          "Yes, you can cancel your subscription at any time. You will still have access to the features until the end of the current billing cycle.",
      },
      {
        question: "Is there a free trial for the paid plans?",
        answer:
          "We currently don't offer a free trial for the paid plans. However, the Free Plan includes basic features like the AI literacy quiz and job impact score, which you can explore before deciding to upgrade.",
      },
    ],
    "Data Privacy and Security": [
      {
        question: "How is my data protected?",
        answer:
          "We take your data privacy and security very seriously. All user data is encrypted, and we adhere to best practices for data protection. Your personal information, quiz results, and career assessments will only be used to provide insights and recommendations for your career development.",
      },
      {
        question: "Is my information shared with third parties?",
        answer:
          "We do not share your personal information with third parties without your consent. Any data shared with third parties is strictly for operational purposes (e.g., course providers) and is protected under our privacy policy.",
      },
    ],
    "Technical Support": [
      {
        question: "I'm experiencing technical issues, how do I get help?",
        answer:
          "If you're encountering issues with the tool, please visit our Support Page or reach out to our customer support team at support@ontrackcareers.ai. Our team will assist you with troubleshooting and resolve any problems you encounter.",
      },
    ],
    "Contact Us": [
      {
        question: "How can I get in touch with you?",
        answer:
          "For any questions, feedback, or inquiries, please feel free to email us at support@ontrackcareers.ai. We are here to help!",
      },
    ],
  };
  return (
    <div>
      <HeaderSection title="Frequently Asked Questions" v />

      <FAQSection faqs={faqJson} />
      <Footer />
    </div>
  );
};
